var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { useContext } from 'react';
import Context, { defaultLanguage } from './Context';

var formatLanguage = function formatLanguage(language) {
  return language.replace(/-/, '');
};

function useLocalization(languages) {
  var language = useContext(Context).language;
  var contextStrings = languages[formatLanguage(language)];
  var fallbackStrings = languages[formatLanguage(defaultLanguage)];
  return {
    strings: __assign(__assign({}, fallbackStrings), contextStrings),
    language: language
  };
}

export default useLocalization;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/localization/hook.js
// module id = 794
// module chunks = 0